// extracted by mini-css-extract-plugin
export var text = "_3o-0";